<template>
  <layout-vertical>

    <!-- Всё содержимое слота — одним элементом. Слот рисуется внутри <transition>
         (LayoutContentRendererDefault), а она показывает только первого потомка:
         когда первым стоял пустой баннер, страница выпадала целиком и кабинет
         показывал пустоту во всех разделах (29.09.2026). -->
    <div class="layout-vertical-slot">
      <!-- Полоса перехода на новый кабинет: в обычной области содержимого,
           навбар и боковое меню ничем не перекрыты. -->
      <new-cabinet-banner />
      <router-view />

      <!-- Код для скачивания приложения: кнопка в левом нижнем углу, не мешает работе -->
      <app-download-qr />
    </div>

    <app-customizer
      v-if="showCustomizer"
      slot="customizer"
    />

  </layout-vertical>
</template>

<script>
import LayoutVertical from '@core/layouts/layout-vertical/LayoutVertical.vue'
import AppDownloadQr from '@/components/AppDownloadQr.vue'
import NewCabinetBanner from '@/components/NewCabinetBanner.vue'
import AppCustomizer from '@core/layouts/components/app-customizer/AppCustomizer.vue'
import { $themeConfig } from '@themeConfig'

export default {
  components: {
    AppCustomizer,
    AppDownloadQr,
    NewCabinetBanner,
    LayoutVertical,
  },
  data() {
    return {
      showCustomizer: $themeConfig.layout.customizer,
    }
  },
}
</script>
